export default __webpack_public_path__ + "locales/tr/WebPlugins.json?hash=d041a9fb60cd58acd45fa5d1c596c777";